import { dayjs } from 'src/helper/date';
import type { ApplianceType } from 'src/helper/shared-types';

export const formatManufactured = (m?: ApplianceType['manufactured']): string | null => {
  if (!m?.month || !m?.year) return null;
  // moment({ year, month: month - 1 }) built a local date on the 1st of that month and
  // rolled an out-of-range month into the next year exactly as the Date constructor
  // does; rebuild the same wall date (month is 1-indexed here → 0-indexed for Date).
  return dayjs(new Date(m.year, m.month - 1, 1)).format('MMMM YYYY');
};

export const formatRegistration = (registrationStatus?: boolean): string | null => {
  if (registrationStatus === undefined || registrationStatus === null) return null;
  return registrationStatus ? 'Registered with manufacturer' : 'Not registered with manufacturer';
};

export const formatAge = (age?: ApplianceType['age']): string | null => {
  if (!Number.isFinite(age?.years)) return null;
  return `${age?.years} yrs`;
};

export const formatExpectedLife = (
  age?: ApplianceType['age'],
): { label: string; colorClass: string } | null => {
  if ((age?.exceeded_by ?? 0) > 0) {
    return { label: `(Exceeded by ${age?.exceeded_by} yrs)`, colorClass: 'text-danger' };
  }
  const remaining = age?.remaining_years;
  if (remaining === undefined) return null;
  if (remaining > 0) return { label: `(${remaining} yrs remaining)`, colorClass: '' };
  return { label: '(Final year of expected life)', colorClass: 'text-warning' };
};
